import type { GetStaticProps, InferGetStaticPropsType } from 'next';
import type { ReactElement } from 'react';

import type { PageProps } from './types';

export function makePagePropsProvider<GetStaticPropsType extends GetStaticProps<PageProps>>(
  PageComponent: React.FC<InferGetStaticPropsType<GetStaticProps<PageProps>>>
): React.FC<InferGetStaticPropsType<GetStaticPropsType>> {
  return function PagePropsProvider({
    sections,
    title,
    seo,
    description,
    slug,
  }: InferGetStaticPropsType<GetStaticPropsType>): ReactElement {
    return <PageComponent sections={sections} title={title} seo={seo} description={description} slug={slug} />;
  };
}
